import React from "react";
import { Route, Redirect } from "react-router-dom";

const DefaultRoute = () => {
  return (
    <Route
      exact
      path="/"
      render={() => {
        return <Redirect to={{ pathname: "/inicio" }} />;
      }}
    />
  );
};

export default DefaultRoute;
